<script setup>
import gsap from 'gsap'

const el = ref(null)
let tl
function initTimeline() {
  const icon = el.value.querySelector('.scroll-down-button__icon')
  tl = gsap
    .timeline({ repeat: -1, repeatDelay: 0.5 })
    .addLabel('part1')
    .to(
      icon,
      {
        y: 18,
        opacity: 0,
        duration: 0.6,
        ease: 'power3.in',
      },
      'part1'
    )
    .to(
      icon,
      {
        scaleX: 0.5,
        scaleY: 1.1,
        duration: 0.6,
        ease: 'power2.in',
      },
      'part1'
    )
    .to(icon, {
      y: -18,
      duration: 0,
    })
    .addLabel('part2')
    .to(
      icon,
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: 'power3.out',
      },
      'part2'
    )
    .to(
      icon,
      {
        scaleX: 1,
        scaleY: 1,
        duration: 0.6,
        ease: 'power2.out',
      },
      'part2'
    )
}

onMounted(() => {
  initTimeline()
})

onBeforeUnmount(() => {
  tl?.kill()
})
</script>

<template>
  <div class="scroll-down-button" ref="el">
    <Icon class="scroll-down-button__icon" name="chevron-down" />

    <svg viewBox="-21 -21 42 42" aria-label="Scroll Down" aria-labelledby="scrollDown scrollDownDesc" role="img">
      <title id="scrollDown">Scroll Down</title>
      <desc id="scrollDownDesc">An illustrated Scroll Down.</desc>
      <defs>
        <clipPath :id="`outline-clip-scrollDown`">
          <circle cx="0" cy="0" r="21" />
        </clipPath>

        <linearGradient
          :id="`outline-gradient-scrollDown`"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="0%"
        >
          <stop offset="0%" stop-color="#6f19f7" />
          <stop offset="100%" stop-color="#c80afb" />
        </linearGradient>

        <linearGradient
          :id="`highlight-gradient-scrollDown`"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="0%"
        >
          <stop offset="0%" stop-color="#ffffff" stop-opacity="0.4" />
          <stop offset="25%" stop-color="#ffffff" stop-opacity="0" />
        </linearGradient>
      </defs>

      <g class="scroll-down-button__highlight-group">
        <circle
          class="scroll-down-button__highlight scroll-down-button__highlight--1"
          cx="0"
          cy="0"
          r="21"
          :stroke="`url(#highlight-gradient-scrollDown)`"
          :clip-path="`url(#outline-clip-scrollDown)`"
        />
        <circle
          class="scroll-down-button__highlight scroll-down-button__highlight--2"
          cx="0"
          cy="0"
          r="21"
          :stroke="`url(#highlight-gradient-scrollDown)`"
          :clip-path="`url(#outline-clip-scrollDown)`"
        />
      </g>
    </svg>
  </div>
</template>

<style lang="scss">
@import '~/styles/utils/functions';
@import '~/styles/utils/variables';
@import '~/styles/vendors/sass-mq/mq';

@import 'styles/utils/timing-functions';

.scroll-down-button {
  position: relative;
  display: block;
  width: 42px;
  height: 42px;

  svg {
    height: 100%;
    width: 100%;
  }

  &__highlight {
    stroke-width: 3px;
    fill: transparent;
    &--2 {
      transform: rotate(180deg);
    }
  }

  &__dot {
    fill: #fff;
  }

  &__highlight {
    opacity: 1;
  }
  &__highlight-group {
    transform: rotate(135deg);
  }
  &__icon {
    position: absolute;
    top: calc(50% - 7px);
    left: calc(50% - 7px);
    width: 14px;
    height: 14px;
  }
}
</style>
